export * from './mini-profile.component';
export * from './mini-profile.module';